<template>
    <div class="setContents noSelect">
        <div class="setContentsMain">
            <div class="LeftDisplay">
                <div class="leftDisplaySelect">
                    <el-popover v-for="(value,index) in displayList"
                                :key="index"
                                popper-class="setContents_pop"
                                class="btnIcon"
                                placement="right"
                                title="标题"
                                width="200"
                                :disabled="editModeConfirmation"
                                trigger="click">
                        <div slot="reference" class="drageDiv"></div>
                        <FSvg slot="reference" class="icon" :title="value.name" color="#999" IconSize="40"></FSvg>
                        <div slot="reference" class="title">{{value.name}}</div>
                        <div class="popup">
                            <el-scrollbar>
                                <div class="box">
                                    <ul>
                                        <li class="img_updoad"
                                            v-if="value.name === '图片'">
                                            <el-upload class="upload-demo"
                                                       action="www.baidu.com"
                                                       :http-request="handlePreview"
                                                       :show-file-list="false">
                                                <FSvg class="icon" title="本地" color="#999" IconSize="50"
                                                      hoverColor="#333" @click="submitUpload"></FSvg>
                                            </el-upload>
                                        </li>
                                        <li v-for="(v,i) in value.checkData" draggable
                                            @dragstart="getDrag(0,$event,index,i,value.type,v)">
                                            <div class="imgDiv" v-if="v.imageUrl !== null">
                                                <img v-if="value.name === '快照'" :src="v.imageUrl">
                                                <img v-if="value.name === '图片'" :src="v.imageUrl">
                                                <img v-if="value.name === '文本'" :src="require(`${v.imageUrl}`)">
                                                <FSvg v-if="value.name === '形状'" color="#aaa" :title="v.imageName"
                                                      IconSize="50"></FSvg>
                                            </div>
                                            <span>{{v.imageName}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </el-scrollbar>
                        </div>
                    </el-popover>
                </div>
            </div>
            <div class="rightEdit">
                <div class="toolList">
                    <!--                    <div class="toolListIn" v-show="clickType === 3">-->
                    <!--                        <el-select class="tool family" v-model="toolList.fontFamily" placeholder="">-->
                    <!--                            <el-option-->
                    <!--                                    v-for="item in toolList.fontFamilyList"-->
                    <!--                                    :key="item"-->
                    <!--                                    :value="item">-->
                    <!--                            </el-option>-->
                    <!--                        </el-select>-->
                    <!--                        <el-select class="tool size" v-model="toolList.fontSize" placeholder="">-->
                    <!--                            <el-option-->
                    <!--                                    v-for="item in toolList.fontSizeList"-->
                    <!--                                    :key="item"-->
                    <!--                                    :value="item">-->
                    <!--                            </el-option>-->
                    <!--                        </el-select>-->
                    <!--                        <FSvg class="tool weight" title="粗体中" v-if="toolList.fontWeight"></FSvg>-->
                    <!--                        <FSvg class="tool weight" title="粗体" v-if="!toolList.fontWeight"></FSvg>-->
                    <!--                        <el-color-picker class="tool" v-model="toolList.fontColor"></el-color-picker>-->
                    <!--                        <FSvg class="tool" color="#999" hoverColor="#999" title="分割"></FSvg>-->
                    <!--                        <FSvg class="tool position" title="居左"-->
                    <!--                              :class="{select:toolList.paragraphPosition === 'left'}"></FSvg>-->
                    <!--                        <FSvg class="tool position" title="居中"-->
                    <!--                              :class="{select:toolList.paragraphPosition === 'center'}"></FSvg>-->
                    <!--                        <FSvg class="tool position" title="居右"-->
                    <!--                              :class="{select:toolList.paragraphPosition === 'right'}"></FSvg>-->
                    <!--                    </div>-->
                    <!--                    <canvas id="myCanvas"  width="200" height="100" style="border:1px solid #d3d3d3;">-->
                    <!--                    </canvas>-->
                    <FBtn class="rightToolBtn" type="2" title="保存" @click.native="dialogshow = !dialogshow">图层</FBtn>
                    <el-input class="toolheight" v-model="canvasPage.height" placeholder="高度" @blur="setElementContent('revise', checkeditem)"></el-input>
                    <div class="editModeConfirmation" v-if="editModeConfirmation">
                        <FSvg class="icon" title="取消" color="#c82915" IconSize="30"
                              @click.native="exitEditMode()"></FSvg>
                        <FSvg class="icon" title="确认" color="#4cc711" IconSize="30"
                              @click.native="saveEditMode()"></FSvg>
                    </div>
                </div>
                <div class="FCanvas" @dragover="allowDrop($event)" @mousemove="getNoCheck($event)"
                     @contextmenu="getNoEvent($event)">
                    <div class="FCanvas_body">
                        <el-scrollbar ref="scrollbar"
                                      :native="false">
                            <div class="FCanvas_Page" id="FCanvas_FaPage" @drop="getDrag(1,$event)"
                                 :style="{height: canvasPage.height + 'px',width:canvasPage.width + 'px'}"
                                @click="onClickParent()">
                                <quill-editor id="editMode"
                                              v-model="textItem"
                                              :options="editorOption"
                                >
                                </quill-editor>
                                <VueDragResize v-for="(item,index) in dragElementList"
                                               :key="item.chartBoxId"
                                               :z="item.transF.zIndex"
                                               :x="item.transF.x"
                                               :y="item.transF.y"
                                               :w="item.transF.width"
                                               :h="item.transF.height"
                                               :id="'FCharsDrog_xy_'+item.chartBoxId"
                                               :preventActiveBehavior="false"
                                               :parentLimitation="true"
                                               :isActive="item.active"
                                               :isDraggable="item.draggable"
                                               :isResizable="item.resizable"
                                               @dragging="dragBoxResize(arguments,index,item)"
                                               @dragstop="dragBoxAdjustEnd(arguments,index,item,'drag')"
                                               @resizing="dragBoxResize(arguments,index,item)"
                                               @resizestop="dragBoxAdjustEnd(arguments,index,item,'resize')"
                                               @clicked="dragBoxMove(index),handleOnClick(arguments,index,item)"
                                               :style="{display:item.show?'block':'none'}"
                                >
                                    <div class="tool_List" v-if="item.active">
                                        <el-input
                                                class="strokeWidth"
                                                v-model="item.svg.strokeWidth"
                                                v-if="item.type === 3  && item.svg.graphicalType === 'stroke'"
                                                size="mini">
                                        </el-input>
                                        <FSvg color="#999" :title="item.svg.graphicalType === 'stroke'?'轮廓':'填充'"
                                              v-if="item.type === 3" @click.native="switchDropSvg(index)"></FSvg>
                                        <el-color-picker class="tool" size="mini" v-model="item.svg.fillColor"
                                                         show-alpha
                                                         v-if="item.type === 3 && item.svg.graphicalType === 'fill'"></el-color-picker>
                                        <el-color-picker class="tool" size="mini" v-model="item.svg.strokeColor"
                                                         show-alpha
                                                         v-if="item.type === 3 && item.svg.graphicalType === 'stroke'"></el-color-picker>
                                        <FSvg color="#999" title="圆叉删除" @click.native="deleteDrop(item,index)"
                                              @mouseenter.native="item.draggable = false"
                                              @mouseleave.native="item.draggable = true"></FSvg>
                                    </div>
                                    <div class="charts_box" v-if="item.type === 0"
                                         :id="'snap_shot_'+item.chartData.id"></div>
                                    <!--                                    <div class="charts_box" v-if="item.type === 0" :id="'snap_shot_'+item.chartId" :style="{background:item.backColor}"></div>-->
                                    <!-- 富文本编辑框 -->
                                    <div class="text_input" v-if="item.type === 1">
                                        <quill-editor
                                                v-model="item.content"
                                                :style="{opacity:item.editMode?'0':'1'}"
                                                @dblclick.native="textDblclick(item,index)"
                                        ></quill-editor>
                                    </div>
                                    <img class="text_img"
                                         draggable="false"
                                         :src="item.imgUrl"
                                         v-if="item.type === 2">
                                    <svg class="text_svg" id="text_svg" v-if="item.type === 3">
                                        <rect class="rect" v-if="item.svg.type === 'rect'" :width="item.transF.width"
                                              :height="item.transF.height" type
                                              :style="{fill:item.svg.fillColor,stroke:item.svg.strokeColor,strokeWidth:item.svg.strokeWidth+'px'}"/>
                                        <ellipse class="ellipse" v-if="item.svg.type === 'ellipse'"
                                                 :cx="item.transF.width" :cy="item.transF.height"
                                                 :rx="item.transF.width" :ry="item.transF.height"
                                                 :style="{fill:item.svg.fillColor,stroke:item.svg.strokeColor,strokeWidth:item.svg.strokeWidth+'px'}"/>
                                        <line class="line" v-if="item.svg.type === 'line'" x1="0" y1="0"
                                              :x2="item.transF.width" :y2="item.transF.height"
                                              style="stroke:rgb(99,99,99);stroke-width:2"/>
                                    </svg>
                                    <!--                                    <canvas class="text_svg" id="myCanvas" v-if="item.type === 3" width="500" height="500" style="border:1px solid #d3d3d3;">-->
                                    <!--                                       </canvas>-->
                                </VueDragResize>
                                <div v-show="chartBorder" class="chart-barder chart-xy-barder-top"></div>
                                <div v-show="chartBorder" class="chart-barder chart-xy-barder-bottom"></div>
                                <div v-show="chartBorder" class="chart-barder chart-xy-barder-left"></div>
                                <div v-show="chartBorder" class="chart-barder chart-xy-barder-right"></div>
                            </div>
                        </el-scrollbar>
                    </div>
                </div>
            </div>
            <div class="layerbox" v-if="dialogshow==true" id="layerBox">
                <div class="orderheader clearFloat" @mousedown="mousedown">
                    <span class="left" @click="demo">图层</span>
                    <span class="right" @click="dialogshow = !dialogshow">
                        <FSvg slot="reference" class="icon" title="X删除" color="#000" IconSize="20"></FSvg>
                    </span>
                </div>
                <div class="orderbody">
                    <div class="draglist">
                        <transition-group tag="div" class="container" id="containerGroup">
                            <div class="dragitem" v-for="(item,index) in dragElementList" :key="item.chartBoxId"
                                 :id="item.chartBoxId"
                                 :class="{select:item.chartBoxId === checkeditem.chartBoxId}"
                                 :style="{drag:item.active}"
                                 draggable="true"
                                 @dragstart="dragBoxClick(index,item),handleDragstart($event)"
                                 @dragover="handleDragenter($event,item,index)"
                                 @dragenter=""
                                 @dragend="handleDragEnter($event,item,index)"
                                 @click="handleOnClick($event,index,item)">
                                <FSvg slot="layer_display" class="icon" :title="item.show?'图层隐藏':'图层显示'"
                                      :color="item.show?'#555':'#999'" IconSize="25"
                                      @click.native.stop="item.show = !item.show,setElementContent('revise', item, index)"></FSvg>
                                <div class="itemname">
                                    <span v-if="item.type===0">{{item.transF.zIndex+'快照'+item.chartBoxId}}</span>
                                    <span v-if="item.type===1">{{item.transF.zIndex+'文本框'+item.chartBoxId}}</span>
                                    <span v-if="item.type===2">{{item.transF.zIndex+'图片'+item.chartBoxId}}</span>
                                    <span v-if="item.type===3">{{item.transF.zIndex+'形状'+item.chartBoxId}}</span>
                                </div>
                                <FSvg slot="layer_display" class="icon" :title="item.draggable?'未锁定图层':'锁定图层'"
                                      color="#999" IconSize="20"
                                      @click.native.stop="handleLockLayer('revise',item,index)"></FSvg>
                            </div>
                        </transition-group>
                    </div>
                </div>
                <div class="orderbtn">
                    <i @click="handleToFirst()">
                        <FSvg slot="layer_display" class="icon" title="置顶" color="#000" IconSize="18"></FSvg>
                    </i>
                    <i @click="handleToLast()">
                        <FSvg slot="layer_display" class="icon" title="置底" color="#000" IconSize="18"></FSvg>
                    </i>
                    <i @click="removeLayer()">
                        <FSvg slot="layer_display" class="icon" title="删除图层" color="#000" IconSize="18"></FSvg>
                    </i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/10 3:00 下午
     */
    import modules from '../charts/script/modules'
    import VueDragResize from 'vue-drag-resize';
    import {getUser} from '@/assets/js/basis'
    import {
        //获取快照列表信息
        getSnapShotList,
        //获取快照图表详情
        getSnapShotInfo,
        //获取故事版内容详情
        getTeamSharingContent,
        //添加修改故事版被人详情
        addorModifyTeamSharingContent,
        //更改故事版内容zindex
        setElementContentIndex,
        //上传图片
        setTeamSharingImg,
        //图片列表
        getImgList,
    } from '@/assets/axios/teamSharing/setContents'
    export default {
        name: 'setContents',
        components: {
            VueDragResize,
        },
        props: {},
        data() {
            return {
                /*-----------文本框开始----------------*/
                // 清除文本框内容
                // isClear: false,
                // 当前操作文本框
                textItem: '',
                // 进入文本编辑模式
                editModeConfirmation: false,
                //文本框编辑配置
                editorOption: {
                    // modules:{
                    //     toolbar:[
                    //         ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    //         ['blockquote', 'code-block']
                    //     ]
                    // }
                },
                //上方工具箱列表
                toolList: {
                    fontFamily: '华文中宋',
                    fontFamilyList: ['宋体', '楷体', '圆体'],
                    fontSize: 10,
                    fontSizeList: [10, 20, 30],
                    fontWeight: 14,
                    fontColor: '#ffffff',
                    paragraphPosition: 'center',
                    strokeWidth: 20,
                    fillColor: '#fff',
                    graphicalType: 'stroke'
                },
                /*-----------文本框结束----------------*/
                /*-----------弹框开始----------------*/
                dialogshow: true,
                //移动的内容
                dragging: null,
                //移动到某个元素 的元素
                draggToElement: null,
                //图层点击选择的元素
                checkeditem: {},
                /*-----------弹框结束----------------*/
                // 当前拖拽的元素种类 0快照 1文本 2图片 3图形
                clickType: null,
                // 当前拖拽的元素索引
                clickIndex: null,
                //拖拽的元素列表索引
                checkDataIndex: null,
                //当前拖拽快照的数据
                clickRequestData: {},
                //左侧列表包括列表中的数据
                displayList: [
                    {
                        name: '快照',
                        type: 0,
                        popupToggle: false,
                        checkData: []
                    },
                    {
                        name: '文本',
                        type: 1,
                        popupToggle: false,
                        checkData: [
                            {
                                imageUrl: "./img/gs00.jpg",
                                imageName: '文本框1'
                            }
                        ]
                    },
                    {
                        name: '图片',
                        type: 2,
                        popupToggle: false,
                        checkData: [
                            {
                                imageUrl: null,
                                imageName: null
                            }
                        ]
                    },
                    {
                        name: '形状',
                        type: 3,
                        popupToggle: false,
                        checkData: [
                            {
                                imageUrl: '',
                                imageName: '矩形'
                            },
                            {
                                imageUrl: '',
                                imageName: '圆形'
                            },
                            // {
                            //     imageUrl: '',
                            //     imageName: '箭头'
                            // }, {
                            //     imageUrl: '',
                            //     imageName: '多边形'
                            // }
                        ]
                    },
                ],
                //内容展示列表
                dragElementList: [],
                //内容展示的层级列表
                zIndexList: [],
                //文本的编辑状态 false未选中 true选中
                textEditStatus: true,
                //延长线开关
                chartBorder: false,
                //大屏尺寸
                canvasPage: {
                    height: 1080,
                    width: 1200
                },
                //配置项
                configType: 0,
            }
        },
        methods: {
            /*----------------------文本框------------------*/
            // 保存文本编辑后的内容
            saveEditMode() {
                this.checkeditem.content = this.textItem;
                this.exitEditMode();
                this.setElementContent('revise', this.checkeditem);
            },
            //双击进入编辑模式
            textDblclick(item, index) {
                item.draggable = false;
                item.resizable = false;
                item.rotatable = false;
                this.editModeConfirmation = true;
                this.checkeditem = item;
                this.checkeditem.index = index;
                let dom = $("#editMode")
                dom.css({
                    width: item.transF.width,
                    height: item.transF.height,
                    display: 'block',
                    top: item.transF.y,
                    left: item.transF.x,
                })
                let tool = dom.children().eq(0);
                dom.children().eq(1).css('overflow', 'auto');
                if (tool.width() > 600) {
                    tool.css({height: 66, top: -66})
                } else if (tool.width() < 600 && tool.width() > 300) {
                    tool.css({height: 130, top: -130})
                } else if (tool.width() > 150 && tool.width() < 300) {
                    tool.css({height: 230, top: -230})
                } else if (tool.width() < 150) {
                    tool.css({height: 330, top: -330})
                }
                item.editMode = true;
                this.textItem = item.content;
            },
            // 退出编辑模式
            exitEditMode() {
                this.editModeConfirmation = false;
                this.checkeditem.editMode = false;
                let dom = $("#editMode");
                dom.css({
                    display: 'none',
                })
                this.dragElementList.map((val, index) => {
                    if (this.checkeditem.chartBoxId === val.chartBoxId) {
                        val.draggable = true;
                        val.resizable = true;
                        val.rotatable = true;
                    }
                })
            },
            /*----------------------图层弹框------------------*/
            //图层弹框移动
            mousedown(event) {
                this.selectElement = document.getElementById('layerBox');
                let div1 = this.selectElement;
                this.selectElement.style.cursor = 'move';
                let distanceX = event.clientX - this.selectElement.offsetLeft;
                let distanceY = event.clientY - this.selectElement.offsetTop;
                document.onmousemove = (ev) => {
                    let oevent = ev || event;
                    div1.style.left = oevent.clientX - distanceX + 'px';
                    div1.style.top = oevent.clientY - distanceY + 'px';
                }
                document.onmouseup = () => {
                    document.onmousemove = null;
                    document.onmouseup = null;
                    div1.style.cursor = 'default';
                }
            },
            // 置顶
            handleToFirst() {
            },
            // 置底
            handleToLast() {

            },

            //图层拖拽开始
            handleDragstart(e) {
                e.dataTransfer.setData("te", e.target.innerText); //不能使用text，firefox会打开新tab
                this.dragging = e.target;
            },
            //图层拖拽中
            handleDragenter(e, item, index) {
                // e.preventDefault(); //取消事件默认动作
                var target = e.target;
                if (target.nodeName === "DIV" && target !== this.dragging) {
                    //_index是实现的获取index
                    if (this._index(this.dragging) < this._index(target)) {
                        try {
                            target.parentNode.insertBefore(this.dragging, target.nextSibling);
                        } catch (e) {

                        }
                    } else {
                        try {
                            target.parentNode.insertBefore(this.dragging, target);
                        } catch (e) {

                        }
                    }
                }

                let ey = e.layerY;
                let positions = 'bottom';
                if (ey < 0) {
                    return
                }
                $('#containerGroup').children().removeClass('dragTop').removeClass('dragBottom');
                if (ey > 0 && ey < 18) {
                    $(`#${item.chartBoxId}`).addClass('dragTop');
                    positions = 'top';
                }
                if (ey > 18 && ey < 36) {
                    $(`#${item.chartBoxId}`).addClass('dragBottom');
                    positions = 'bottom';
                }
                this.draggToElement = item;
                this.draggToElement.position = positions;
            },
            _index(el) {
                var index = 0;
                if (!el || !el.parentNode) {
                    return -1;
                }
                while (el && (el = el.previousElementSibling)) {
                    index++;
                }
                return index;
            },
            //图层的拖拽结束
            handleDragEnter(e, item) {
                this.setzIndexListRefresh();
                this.setElementContentIndex('revise');
                $('#containerGroup').children().removeClass('dragTop').removeClass('dragBottom');
            },
            // 删除图层
            removeLayer() {
                if (this.checkeditem === {}) {
                    return
                }
                this.dragElementList.map((val, ind) => {
                    if (val.chartBoxId === this.checkeditem.chartBoxId) {
                        this.setElementContent('delete', this.checkeditem, ind);
                        this.dragElementList.splice(ind, 1);
                    }
                })
            },
            // 锁定解锁图层
            handleLockLayer(type, item, index) {
                item.draggable = !item.draggable,
                    item.resizable = !item.resizable,
                    item.rotatable = !item.rotatable,
                    this.setElementContent(type, item, index)
            },
            // 图层点击
            handleOnClick(e, index, item) {
                this.dragBoxClick(index, item);
                if (!this.editModeConfirmation) {
                    this.checkeditem = item;
                    this.checkeditem.index = index;
                    return
                }
                ;
            },
            /*----------------------弹框结束------------------*/
            // 获取快照列表
            getSnapshotList() {
                getSnapShotList().then((res) => {
                    if (res.code === 200) {
                        this.displayList[0].checkData = res.data.dataTabel;
                        this.displayList[0].checkData.map((val,index)=>{
                            if(val.imageName === null){
                                val.imageName = '无缩略图'
                            }
                            if(val.imageUrl === null){
                                val.imageUrl = require("./img/nullSmImg.png")
                            }
                        })
                        this.displayList[0].checkData = res.data.dataTabel;
                    }
                })
            },
            // imageUrl
            getImgList() {
                getImgList().then(res => {
                    if (res.code === 200) {
                        this.displayList[2].checkData = res.data.dataTabel
                    }
                })
            },
            // 获取页面内容
            getElementContent(id) {
                if (id !== undefined) {
                    getTeamSharingContent({storyBoardID: id}).then((res) => {
                        if (res.code === 200) {
                            if (res.message !== '无值') {
                                this.dragElementList = [];
                                res.data.dataTable.info.map((val, index) => {
                                    let a = {};
                                    a = JSON.parse(val.contentJson);
                                    a.chartBoxId = val.id;
                                    a.storyBoardID = val.storyBoardID;
                                    if (a.type === 0) {
                                        this.createChart(a.chartData, a.chartBoxId);
                                    }
                                    this.dragElementList.unshift(a);
                                    this.checkeditem = a;
                                    this.checkeditem.index = index;
                                });
                                this.zIndexList = JSON.parse(res.data.dataTable.rankJson);
                                //根据zIndexList 重新排列 dragElementList
                                this.setElementContentIndexRefresh();
                                this.rearrangedragElementList('dragList');
                                this.canvasPage.height = res.data.dataTable.height;
                                // this.dragElementList = JSON.parse(res.data.dataTable[0].contentJson);
                                // this.canvasPage.height = res.data.dataTable[0].height;
                            }
                        }
                    })
                }
            },
            //根据快照id查询快照详情
            getSnapShotInfo(id, index) {
                getSnapShotInfo({snapShotID: id}).then((res) => {
                    if (res.code === 200) {
                        this.clickRequestData = res.data.dataTable[0];
                    }
                })
            },
            //上传图片
            handlePreview(val) {
                let fd = new FormData();
                fd.append('file', val.file);
                setTeamSharingImg(fd).then((res) => {
                    if (res === 200) {
                        this.$message({
                            message: '添加成功！',
                            type: 'success'
                        });
                        this.getImgList();
                    }
                })
            },
            //修改 删除 添加 页面中的内容
            setElementContent(type, centent, index) {
                addorModifyTeamSharingContent(
                    {
                        storyBoardID: this.$route.query.id,
                        contentJson: JSON.stringify(centent),
                        height: this.canvasPage.height,
                        type: type,
                        id: centent.chartBoxId || '',
                    }).then((res) => {
                    if (res.code !== 200) {
                        this.$message({
                            type: 'warning',
                            message: `操作未保存，请检查网络连接！`
                        });
                        if (type === 'add') {
                            this.dragElementList.map((val, index) => {
                                if (val.chartBoxId === centent.chartBoxId) {
                                    this.dragElementList.splice(index, 1)
                                }
                            })
                        } else if (type === 'revise') {

                        } else if (type === 'delete') {
                        }
                    } else {
                        if (type === 'add') {
                            centent.chartBoxId = res.data.dataTable.storyBoardInfoId;
                            if (centent.type === 0) {
                                this.$nextTick(() => {
                                    this.clickRequestData.id = res.data.dataTable.storyBoardInfoId;
                                    centent.chartData = this.clickRequestData
                                })
                                this.createChart(this.clickRequestData, res.data.dataTable.storyBoardInfoId,type);
                            }
                            this.setElementContentIndex(type, res.data.dataTable.storyBoardInfoId);
                        } else if (type === 'revise') {
                        } else if (type === 'delete') {
                            this.setElementContentIndex(type, res.data.dataTable.storyBoardInfoId);
                        }
                    }

                })
            },
            //dragover
            allowDrop(ev) {
                //取消事件的默认动作。
                ev.preventDefault();
            },
            //生成图表 文字 图片 等    type=0 选择拖拽的元素  type=3
            /*type 拖拽开始0 拖拽生成
            ev      $event
            index  快照文本图片形状索引
            i      某个index的内容中的索引
            typeNumber
            */
            getDrag(type, ev, index, i, typeNumber, val) {
                if (type === 0) {
                    this.checkDataIndex = i;
                    this.clickType = typeNumber;
                    this.clickRequestData = null;
                    if (typeNumber === 0) {
                        this.getSnapShotInfo(val.snapShotID, index);
                    }
                    // ev.dataTransfer.setData("data-url", data.url);
                    // ev.dataTransfer.setData("data-type", data.type);
                    // let url = ev.dataTransfer.getData("data-url");
                }
                if (type === 1) {
                    let FaPage = $('#FCanvas_FaPage');
                    let x = ev.pageX - (FaPage.offset().left - $("body").scrollLeft());
                    let y = ev.pageY - (FaPage.offset().top - $("body").scrollTop());
                    let elX = FaPage.width();
                    let elY = FaPage.height();
                    let itemW = 100;
                    let itemH = 100;
                    if (x >= elX || (x + (itemW / 2)) >= elX) {
                        x = elX - itemW;
                    } else if (x <= (itemW / 2)) {
                        x = 0;
                    } else {
                        x = x - (itemW / 2);
                    }
                    if (y >= elY || (y + (itemH / 2)) >= elY) {
                        y = elY - itemH;
                    } else if (y <= (itemH / 2)) {
                        y = 0;
                    } else {
                        y = y - (itemH / 2);
                    }

                    let resource = {
                        transF: {
                            x: x,
                            y: y,
                            width: itemW,
                            height: itemH,
                            //角度
                            rotation: 0,
                            zIndex: this.zIndexList.length + 1,
                        },
                        minWidth: 50,
                        minHeight: 50,
                        //能否旋转
                        rotatable: true,
                        //能否调整大小
                        resizable: true,
                        //能否移动
                        draggable: true,
                        //接受率
                        acceptRatio: false,
                        //显示边框
                        active: false,
                        //显示
                        show: true,
                        //
                        chartBoxId: "5313418646384861324864",
                        chartData: {
                            id: "123123t534654645"
                        }
                    };

                    if (this.clickType === 0) {
                        resource.type = 0;
                        resource.chartId = this.clickRequestData.id;
                        resource.chartData = {};
                        for (let val in this.clickRequestData) {
                            resource.chartData[val] = this.clickRequestData[val];
                        }
                        this.dragElementList.unshift(resource);
                    } else if (this.clickType === 1) {
                        resource.type = 1;
                        let itemW = 640;
                        let itemH = 50;
                        resource.transF.width = itemW;
                        resource.transF.height = itemH;
                        resource.minWidth = itemW;
                        resource.minHeight = itemH;
                        resource.content = '';
                        resource.showHead = false;
                        resource.minWidth = 632;
                        resource.editMode = true,
                            this.dragElementList.unshift(resource);
                        this.textDblclick(resource, this.dragElementList.length)
                    } else if (this.clickType === 2) {
                        resource.type = 2;
                        resource.imgUrl = this.displayList[2].checkData[this.checkDataIndex].imageUrl,
                            this.dragElementList.unshift(resource);
                    } else if (this.clickType === 3) {
                        resource.type = 3;
                        resource.svg = {
                            graphicalType: 'fill',
                            fillColor: '#000',
                            strokeColor: '',
                            strokeWidth: '',
                        };
                        if (this.checkDataIndex === 0) {
                            resource.svg.type = 'rect'
                        } else if (this.checkDataIndex === 1) {
                            resource.svg.type = 'ellipse'
                        } else if (this.checkDataIndex === 2) {

                        }

                    }
                    ;

                    this.setElementContent('add', resource, this.dragElementList.length - 1);
                }
            },
            //生成真实数据图表
            createChart(data, boxId, type) {
                let modu = modules;
                let nodeData = data;
                nodeData.id = boxId;
                this.$nextTick(() => {
                    this.$store.dispatch('viewDPSnapshot', {modu, nodeData});
                })
            },
            //删除图表文字图片等
            deleteDrop(item, index) {
                this.setElementContent('delete', item, index);
                this.dragElementList.splice(index, 1);
            },
            // 更改页面内容zindex
            setElementContentIndex(type, id) {
                if (type === 'add') {
                    this.zIndexList.unshift({
                        id: id,
                        zIndex: this.zIndexList.length + 1
                    })
                }
                if (type === 'delete') {
                    this.zIndexList.map((value, index) => {
                        if (value.id === id) {
                            this.zIndexList.splice(index, 1)
                        }
                    })
                    //删除一项 就更新zindex值
                    this.setzIndexListRefresh();
                    this.rearrangedragElementList('zIndex');
                }
                setElementContentIndex({
                    id: this.$route.query.id,
                    rankJson: JSON.stringify(this.zIndexList)
                }).then((res) => {
                    if (res.code == 200) {
                        if (type === 'delete' || type === 'revise') {
                            this.setElementContentIndexRefresh();
                        }
                    }
                })
            },
            // 刷新dragElementList中的zindex
            setElementContentIndexRefresh() {
                this.zIndexList.map((zv) => {
                    this.dragElementList.map((ev) => {
                        if (zv.id === ev.chartBoxId) {
                            ev.transF.zIndex = zv.zIndex;
                        }
                    })
                });
            },
            //根据zIndex重新排列dragElementList
            rearrangedragElementList(type) {
                if (type === 'dragList') {
                    var len = this.dragElementList.length;
                    for (var i = 0; i < len - 1; i++) {
                        for (var j = 0; j < len - 1 - i; j++) {
                            // 相邻元素两两对比，元素交换，大的元素交换到后面
                            if (this.dragElementList[j].transF.zIndex < this.dragElementList[j + 1].transF.zIndex) {
                                var temp = this.dragElementList[j];
                                this.dragElementList[j] = this.dragElementList[j + 1];
                                this.dragElementList[j + 1] = temp;
                            }
                        }
                    }
                } else if (type === 'zIndex') {
                    var len = this.zIndexList.length;
                    for (var i = 0; i < len - 1; i++) {
                        for (var j = 0; j < len - 1 - i; j++) {
                            // 相邻元素两两对比，元素交换，大的元素交换到后面
                            if (this.zIndexList[j].zIndex < this.zIndexList[j + 1].zIndex) {
                                var temp = this.zIndexList[j];
                                this.zIndexList[j] = this.zIndexList[j + 1];
                                this.zIndexList[j + 1] = temp;
                            }
                        }
                    }
                    this.setElementContentIndexRefresh();
                }

            },
            // 获取Dom元素刷新zindex值
            setzIndexListRefresh() {
                let handleDom = $('#containerGroup').children();
                let a = [];
                handleDom.map((value, index, array) => {
                    a.push({
                        id: handleDom[value].id,
                        zIndex: this.zIndexList.length - value
                    })
                })
                this.zIndexList = a;
            },
            //轮廓 填充切换
            switchDropSvg(index) {
                if (this.dragElementList[index].svg.graphicalType === 'fill') {
                    this.dragElementList[index].svg.graphicalType = 'stroke';
                    this.dragElementList[index].svg.strokeColor = this.dragElementList[index].svg.fillColor;
                    this.dragElementList[index].svg.strokeWidth = '10';
                    this.dragElementList[index].svg.fillColor = 'rgba(0,0,0,0)';

                } else {
                    this.dragElementList[index].svg.graphicalType = 'fill';
                    this.dragElementList[index].svg.fillColor = this.dragElementList[index].svg.strokeColor;
                    this.dragElementList[index].svg.strokeColor = 'rgba(0,0,0,0)';
                }
            },
            //更改toolList
            setToolList(item) {
            },
            //拖动块 上浮时
            dragBoxClick(index, item, e) {
                if (this.clickIndex === index) {
                    return;
                }
                this.clickType = item.type;
                this.clickIndex = index;
                if (item.type === 3) {
                    this.setToolList(item);
                }
                this.dragElementList.map((item) => {
                    item.active = false;
                });
                this.dragElementList[index].active = true;
            },
            //拖动块调整完成
            dragBoxAdjustEnd(obj, index, item, type) {
                this.setElementContent('revise', item, index);
                if (item.type === 0) {
                    if (type === 'resize') {
                        this.createChart(item.chartData, item.chartBoxId);
                    }
                }
            },
            //拖动块 改变时
            dragBoxResize(obj, index, item) {
                this.dragElementList.map((v, i) => {
                    if (i === index) {
                        v.transF.x = obj[0].left;
                        v.transF.y = obj[0].top;
                        v.transF.width = obj[0].width;
                        v.transF.height = obj[0].height;
                    }
                });
                this.dragBoxMove(index);
            },
            //拖动块 边框线
            dragBoxMove(index, event) {
                // $('.ql-toolbar').css('display','block')
                
                let transF = this.dragElementList[index].transF;
                let w1 = transF.x + (transF.width / 2) + 'px';
                let w2 = (transF.height / 2) + 'px';
                let h1 = transF.y + (transF.height / 2) + 'px';
                let h2 = (transF.width / 2) + 'px';
                $('.chart-xy-barder-top').css({
                    top: transF.y,
                    transform: 'rotate(' + transF.rotation + 'deg)',
                    transformOrigin: w1 + ' ' + w2
                });
                $('.chart-xy-barder-bottom').css({
                    top: transF.y + transF.height,
                    transform: 'rotate(' + transF.rotation + 'deg)',
                    transformOrigin: w1 + ' -' + w2
                });
                $('.chart-xy-barder-left').css({
                    left: transF.x,
                    transform: 'rotate(' + transF.rotation + 'deg)',
                    transformOrigin: h2 + ' ' + h1
                });
                $('.chart-xy-barder-right').css({
                    left: transF.x + transF.width,
                    transform: 'rotate(' + transF.rotation + 'deg)',
                    transformOrigin: '-' + h2 + ' ' + h1
                });
                this.chartBorder = true;
                this.dragBoxClick(index, this.dragElementList[index].type);
            },
            //鼠标在父级移动
            getNoCheck(event) {
                let divName = event.toElement.id;
                if (divName === 'FCanvas_FaPage') {

                    // $('.ql-toolbar').css('display','none')
                    this.chartBorder = false;
                    // this.checkeditem = {};
                    this.clickIndex = null;
                }
            },
            //鼠标在父级点击
            onClickParent(){
                let divName = event.toElement.id;
                if (divName === 'FCanvas_FaPage') {
                    this.dragElementList.map((item) => {
                        item.active = false;
                    });
                }

            },
            //关闭左侧所有弹框
            setWholeBox() {
                this.displayList.map((val) => {
                    val.popupToggle = false;
                })
            },
            //关闭左侧弹框
            setShowBox(index) {
                this.clickIndex = index;
                if (this.displayList[index].popupToggle) {
                    this.setWholeBox();
                } else {
                    this.setWholeBox();
                    this.displayList[index].popupToggle = true;
                }
            },
            submitUpload() {
                this.displayList[2].popupToggle = true;
            },
            //链接signalR
            linkSignalR(storyBoardId, userId) {
                this.signalr.start().then(() => {
                    this.signalr.invoke('InitUser', storyBoardId, userId);
                    this.signalr.on('ActionOnline', (code, data) => {
                        if (code === 200) {
                            this.signalr.on('ActionPush', (type, json, id) => {
                                this.setDragElementList(type, JSON.parse(json), id)
                            })
                            this.signalr.on('RankJsonPush', (json, id) => {
                                this.setDragElementList('handleRevise', JSON.parse(json), id)
                            })
                        }
                    })
                })
            },
            //signalR被动操作元素
            setDragElementList(type, json, id) {
                if (type === 'add') {
                    json.chartBoxId = id;
                    this.dragElementList.push(json);
                    if (json.type === 0) {
                        this.createChart(json.chartData, json.chartBoxId);
                    }
                } else if (type === 'revise') {
                    this.dragElementList.map((val, index) => {
                        if (val.chartBoxId === id) {
                            this.dragElementList[index] = json;
                            if (json.type === 0) {
                                this.createChart(json.chartData, json.chartBoxId);
                            }
                        }
                    })
                } else if (type === 'delete') {
                    this.dragElementList.map((val, index) => {
                        if (val.chartBoxId === id) {
                            this.dragElementList.splice(index, 1)
                        }
                    })
                } else if (type === 'handleRevise') {
                    this.zIndexList = json;
                    this.setElementContentIndexRefresh();
                    this.rearrangedragElementList('dragList');
                }
                this.$forceUpdate()
            },
            demo() {
                var c = document.getElementById("myCanvas");
                var cans = c.getContext("2d");
                //画出中心红点
                cans.beginPath();//开始绘制新路径
                //arc(x, y, radius, startAngle, endAngle, counterclockwise)：
                //以(x,y)为圆心绘制一条弧线，弧线半径为radius，起始和结束角度（用弧度表示）分别为startAngle 和endAngle。最后一个参数表示startAngle 和endAngle 是否按逆时针方向计算，值为false表示按顺时针方向计算。
                cans.arc(250, 250, 5, 0, 2 * Math.PI);//参数1：左右移动；参数2：上下移动；参数3：大小；参数4：图形显示百分比
                cans.closePath();
                cans.fillStyle = 'red';
                cans.fill();
                //画线
                arrow_line("myCanvas", 250, 250, 0, 0, 150, 0);   //横  （向右）
                arrow_line("myCanvas", 0, 0, 0, 0, 0, 150);   //竖 (向下)
                arrow_line("myCanvas", -150, 0, 150, 0, 0, 0);   //横  （向左）
                arrow_line("myCanvas", 150, -150, 0, 150, 0, 0);   //竖 (向上)
                //画带箭头的线
                function arrow_line(canId, ox, oy, x1, y1, x2, y2) {
                    //参数说明 canvas的 id ，原点坐标  第一个端点的坐标，第二个端点的坐标
                    var sta = new Array(x1, y1);
                    var end = new Array(x2, y2);
                    var canvas = document.getElementById(canId);
                    if (canvas == null) return false;
                    var ctx = canvas.getContext('2d');
                    //画线
                    ctx.beginPath();
                    ctx.translate(ox, oy, 0); //坐标源点
                    ctx.moveTo(sta[0], sta[1]);
                    ctx.lineTo(end[0], end[1]);
                    ctx.fill();
                    ctx.stroke();
                    ctx.save();
                    //画箭头
                    ctx.translate(end[0], end[1]);
                    //我的箭头本垂直向下，算出直线偏离Y的角，然后旋转 ,rotate是顺时针旋转的，所以加个负号
                    var ang = (end[0] - sta[0]) / (end[1] - sta[1]);
                    ang = Math.atan(ang);
                    if (end[1] - sta[1] >= 0) {
                        ctx.rotate(-ang);
                    } else {
                        ctx.rotate(Math.PI - ang);//加个180度，反过来
                    }
                    ctx.lineTo(-5, -10);
                    ctx.lineTo(0, -5);
                    ctx.lineTo(5, -10);
                    ctx.lineTo(0, 0);
                    ctx.fill(); //箭头是个封闭图形
                    ctx.restore();   //恢复到堆的上一个状态，其实这里没什么用。
                    ctx.closePath();
                }

            }
        },
        mounted() {
            // SignalR
            this.linkSignalR(this.$route.query.id, getUser().id);
            // 获取快照列表
            this.getSnapshotList();
            // 获取图片列表
            this.getImgList();
            // 获取页面内容
            setTimeout(() => {
                if (this.$route.query.id === undefined) {
                    this.$router.push({path: 'teamSharing'});
                } else {
                    this.getElementContent(this.$route.query.id)
                }
            }, 200)

        },
        destroyed() {

        },

    }
</script>

<style lang="less">
    @borderRadio: 5px;
    @borderColor: #ccc;
    @shadow: 0 0 15px @h_top_backColor;
    @conBackWLS: #eaeaea;
    @cenMargin: 15px;
    @minMargin: 20px;
    @saveHeight: 80px;
    @dp_fontColor: #fff;
    //图表弹出框
    @pop_back: #272936;
    @pop_bor: hsl(@green, 50%);
    .setContents {
        position: relative;
        background-color: @h_main_backColor !important;
        padding: 0 !important;

        .setContentsMain {
            width: 100%;
            height: 100%;

            .LeftDisplay {
                height: 100%;
                width: 5%;
                display: inline-block;
                vertical-align: top;
                float: left;
                margin-right: 1%;
                position: relative;
                background-color: #fff;
                border-radius: 10px;

                .leftDisplaySelect {
                    position: absolute;
                    transform: translateX(-50%);
                    left: 50%;
                    height: calc(100% - 30px);
                    margin-top: 30px;

                    .btnIcon {
                        width: 100%;
                        position: relative;
                        cursor: pointer;
                        display: block;
                        margin-bottom: 20px;
                        text-align: center;

                        .drageDiv {
                            position: absolute;
                            width: 100%;
                            height: 100%;
                            border-radius: 5px;
                            top: 0;
                            left: 0;
                            z-index: 2;
                        }

                        .icon {
                            margin-bottom: 10px;
                        }

                    }

                }


            }

            .rightEdit {
                width: 94%;
                height: 100%;
                display: inline-block;
                vertical-align: top;
                float: left;
                background-color: @h_path_backColor;
                padding: 10px;
                border-radius: 10px;
                position: relative;

                .toolList {
                    width: 100%;
                    height: 6%;
                    margin-bottom: 10px;
                    border-radius: 5px;
                    line-height: 40px;
                    padding: 5px;

                    .toolListIn {
                        width: 80%;
                        display: inline-block;
                        vertical-align: top;

                        .tool {
                            display: inline-block;
                            vertical-align: top;
                            margin-right: 10px;

                            .el-input {
                                > input {
                                    background: rgba(227, 227, 227, 0.84);
                                    border: none;
                                }
                            }
                        }

                        .family {
                            width: 120px;
                        }

                        .size {
                            width: 70px;
                        }

                        .select {
                            > div {
                                vertical-align: middle;
                                display: inline-block;
                            }

                            /*.el-color-picker {*/
                            /*    .el-color-picker__trigger {*/
                            /*        border: none !important;*/
                            /*        padding: 5px !important;*/
                            /*    }*/
                            /*}*/
                        }
                    }

                    .toolheight {
                        width: 80px;
                        display: inline-block;
                        vertical-align: top;
                        float: right;
                        height: 100%;

                        > input {
                            background: rgba(227, 227, 227, 0.84);
                            border: none;
                        }
                    }

                    .rightToolBtn {
                        display: inline-block;
                        vertical-align: top;
                        float: right;
                        height: 100%;
                        margin-left: 10px;

                        > .FBtn_type_2 {
                            height: 40px;

                            > span {
                                line-height: 40px;
                                height: 40px;
                            }
                        }
                    }

                    .editModeConfirmation {
                        display: inline-block;
                        vertical-align: top;
                        float: right;
                        height: 100%;
                        margin-right: 10px;

                        .icon {
                            margin-right: 10px;
                        }
                    }
                }

                .FCanvas {
                    height: calc(94% - 10px);
                    width: 100%;
                    border-radius: 5px;
                    border: 1px solid #999;
                    background-color: @h_path_backColor;
                    position: relative;

                    .FCanvas_body {
                        width: 100%;
                        height: 100%;
                        display: inline-block;
                        position: relative;
                        border-radius: 5px;
                        overflow: auto;
                        background: #ddd;

                        .el-scrollbar {
                            width: 100%;
                            height: 100%;

                            .el-scrollbar__wrap {
                                overflow-x: hidden;
                            }

                            .el-scrollbar__view {
                                > div {
                                    position: relative;
                                    transform-origin: 0 0;
                                }
                            }
                        }

                        .FCanvas_Page {
                            position: relative;
                            margin: 0 auto;
                            background: #fff;

                            #editMode {
                                position: absolute;
                                display: none;
                                z-index: 9999999;

                                .ql-toolbar {
                                    position: absolute;
                                    top: -66px;
                                    height: 66px;
                                    background: #fff;
                                }

                                .ql-container {
                                    height: 100%;
                                    width: 100%;

                                }
                            }

                            .vdr {
                                /*background-color: #00a65a;*/
                                z-index: 0;

                                .charts_box {
                                    width: 100%;
                                    height: 100%;
                                    color: #fff;
                                    font-size: 30px;
                                    text-align: center;
                                }

                                .text_input {
                                    width: 100%;
                                    height: 100%;
                                    outline: none;
                                    resize: none;
                                    border: none;
                                    background: transparent;
                                    /*transform: scale(0.96);*/

                                    .quill-editor {
                                        position: relative;
                                        width: 100%;
                                        height: 100%;

                                        .ql-toolbar {
                                            display: none;
                                        }

                                        .ql-container {
                                            border: none;

                                            .ql-editor {
                                                overflow: hidden;
                                            }
                                        }
                                    }
                                }

                                .text_img {
                                    width: 100%;
                                    height: 100%;
                                }

                                .text_svg {
                                    width: 100%;
                                    height: 100%;

                                    > * {
                                        width: 100%;
                                        height: 100%;
                                    }

                                    .ellipse {
                                        transform: scale(0.498);
                                    }
                                }

                                .tool_List {
                                    position: absolute;
                                    top: 0;
                                    right: 0;
                                    z-index: 9999999999;

                                    .strokeWidth {
                                        width: 35px;

                                        > input {
                                            background-color: transparent;
                                            border: 0;
                                            padding: 0;
                                            font-size: 20px;
                                        }
                                    }

                                    > div {
                                        vertical-align: middle;
                                        display: inline-block;
                                    }

                                    .el-color-picker {
                                        .el-color-picker__trigger {
                                            border: none !important;
                                            padding: 5px !important;
                                        }
                                    }
                                }

                                .box_z_index {
                                    position: absolute;
                                    top: -20px;
                                    left: 1px;
                                    background: #999;
                                    padding: 2px;
                                }
                            }

                            .chart-barder {
                                position: absolute;
                                z-index: 999;
                            }

                            .linBorTop {
                                border-top: 1px dashed #999;
                            }

                            .linBorLeft {
                                border-left: 1px dashed #999;
                            }

                            .chart-xy-barder-top {
                                width: 100%;
                                .linBorTop;
                            }

                            .chart-xy-barder-bottom {
                                width: 100%;
                                .linBorTop;
                            }

                            .chart-xy-barder-left {
                                height: 100%;
                                .linBorLeft;
                            }

                            .chart-xy-barder-right {
                                height: 100%;
                                .linBorLeft;
                            }
                        }
                    }
                }
            }

            /*图层弹框*/

            .layerbox {
                position: absolute;
                bottom: 100px;
                right: 20px;
                width: 300px;
                height: 400px;
                border: 1px solid #ccc;
                border-radius: 8px;
                z-index: 999999;
                background: #fff;

                .orderheader {
                    height: 50px;
                    line-height: 30px;
                    padding: 10px;
                    background: #e5e5e5;
                }

                .orderbody {
                    height: calc(100% - 50px - 32px);
                    /*padding:5px 20px;*/

                    .adjustposition {
                        width: 60%;
                        padding: 5px 20px;
                        margin: 0 auto;

                        i {
                            display: inline-block;
                            margin: 0 10px;
                            width: 14px;
                            height: 24px;
                            cursor: pointer;

                            &:hover {
                                svg {
                                    fill: #EC6941;
                                }
                            }

                            svg {
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }

                }

                .draglist {
                    height: 100%;
                    overflow-y: scroll;
                    position: relative;

                    .dragitem {
                        border-top: 1px solid #ccc;
                        padding: 6px 8px;
                        background: #f6f6f6;
                        height: 36px;

                        cursor: pointer;

                        .el-checkbox-group {
                            display: inline-block;
                        }

                        .layer_display {
                            display: inline-block;
                            vertical-align: top;
                        }

                        .itemname {
                            display: inline-block;
                            vertical-align: top;
                            margin-left: 10px;
                            line-height: 22px;
                            height: 22px;
                            font-size: 13px;
                            width: calc(100% - 25px - 10px - 25px);
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;

                            > span {

                            }
                        }

                        /*border-bottom:1px solid #ccc;*/
                    }

                    .dragTop {
                        border-top: 2px solid #3bdbffc4;
                    }

                    .dragBottom {
                        border-bottom: 2px solid #3bdbffc4;
                    }

                    .select {
                        border-top: 1px solid #ccc;
                        background: #ffebcc;
                    }
                }

                .orderbtn {
                    background: #e5e5e5;
                    height: 32px;
                    line-height: 32px;
                    border-radius: 0px 0px 8px 8px;
                    text-align: left;

                    i {
                        display: inline-block;
                        width: 16px;
                        height: 16px;
                        line-height: 16px;
                        margin: 5px;
                        cursor: pointer;

                        &:hover {
                            svg {
                                fill: #EC6941;
                            }
                        }

                        svg {
                            width: 100%;
                            height: 100%;
                        }
                    }

                }

            }
        }

    }

    .setContents_pop {
        padding: 10px;
        border-color: @pop_bor !important;
        width: 400px !important;
        height: 300px;

        .el-popover__title {
            display: none;
        }

        .popup {
            width: 100%;
            height: 100%;

            .el-scrollbar {
                width: 100%;
                height: 100%;

                .el-scrollbar__wrap {
                    overflow-x: hidden;

                    .box {
                        width: 100%;
                        height: 100%;
                        overflow: auto;

                        > ul {
                            height: 100%;
                            border-radius: 5px;
                            margin-top: 10px;
                            min-height: 180px;

                            .img_updoad {
                                > div {
                                    transform: translateX(-50%);
                                    left: 50%;
                                    position: absolute;
                                }
                            }

                            li {
                                width: calc(100% / 3 - 15px);
                                height: 100px;
                                border-radius: 5px;
                                margin: 5px;
                                position: relative;
                                display: inline-block;
                                vertical-align: top;
                                cursor: pointer;
                                padding: 5px;
                                border: 1px dashed rgba(19, 179, 175, 0);
                                .drageDiv {
                                    position: absolute;
                                    width: 100%;
                                    height: 100%;
                                    border-radius: 5px;
                                    top: 0;
                                    left: 0;
                                    z-index: 2;
                                }

                                .imgDiv {
                                    width: 100%;
                                    height: 70%;
                                    display: inline-block;
                                    text-align: center;
                                    overflow: hidden;

                                    > img {
                                        height: 100%;
                                        margin: 0 auto;
                                    }
                                }

                                > span {
                                    .text_oneLine;
                                    color: #13b3af;
                                    letter-spacing: 1px;
                                    font-size: 16px;
                                    width: 100%;
                                    line-height: 1;
                                    display: inline-block;
                                    text-align: center;
                                }
                            }

                            li:hover{
                                border: 1px dashed #13b3af ;
                                >span{
                                    color: #14f1ed;
                                }
                            }
                        }
                    }

                }
            }

        }

        .chart_chil {
            width: calc(100% + 5px);
            height: 100%;
            display: inline-block;

            .drageDiv {
                position: absolute;
                width: 100%;
                height: 100%;
                border-radius: 5px;
                top: 0;
                left: 0;
                z-index: 2;
            }

            .chart_d {
                width: 120px;
                margin-right: 5px;
                padding: 5px 5px 0;
                float: left;
                cursor: pointer;
                position: relative;
                border: 1px dashed transparent;

                > img {
                    width: 100%;
                    max-height: 80px;
                }

                > span {
                    text-align: center;
                    display: inline-block;
                    line-height: 20px;
                    font-size: 12px;
                    letter-spacing: 2px;
                    width: 100%;
                    color: @dp_fontColor;
                    .text_oneLine;
                }
            }

            .chart_d:hover {
                border: 1px dashed @green;
                border-radius: @borderRadio;
                background-color: hsl(@green, 13%);
            }
        }

        .popper__arrow {
            left: -7px !important;
            border-right-color: @pop_bor !important;
        }

        .popper__arrow::after {
        }
    }

</style>
